import React from 'react';
import './ProcedureProviderContainer.scss';

const ProviderContainerSearchPage = ({
  img,
  text,
  wrapperClass = '',
  textPostfix = '',
  ariaLabel = '',
  children,
}) => {
  return (
    <div className={`main-wrapper ${wrapperClass}`}>
      <div className="sr-only">{ariaLabel}</div>
      <div className="img-text-container">
        <div className="text-container" aria-label={text}>
          {text} <span aria-hidden={true}>{textPostfix}</span>
        </div>
      </div>
      <div className="third-container">{children}</div>
    </div>
  );
};

export default ProviderContainerSearchPage;
